export default {
  objectType : 'boat',
  attrName : 'Boat Name',
  renderer : props => props?.row?.original?.data?.data?.vessel?.name ?? '-'
} 
